import styled from 'styled-components';

export const ExtratoCard = styled.section`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 18px 20px 20px;
  margin-bottom: 20px;
  box-shadow:
    0 4px 6px -1px rgba(15, 23, 42, 0.07),
    0 2px 4px -2px rgba(15, 23, 42, 0.05),
    0 0 0 1px rgba(255, 255, 255, 0.8) inset;
`;

export const ExtratoCardTitle = styled.h2`
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-align: center;
  margin: 0 0 14px;
  color: #1565c0;
`;

/** Filtro (esquerda) + botões de exportação/cobrança (direita), mesmo card */
export const ChargeFilterAndActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 18px 22px;
`;

export const ChargeFilterPanelWrap = styled.div`
  flex: 1 1 300px;
  min-width: 0;
`;

export const ChargeActionsWrap = styled.div`
  flex: 0 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
  padding: 14px 16px;
  align-self: stretch;
  background: linear-gradient(165deg, #fbfcfe 0%, #f1f5f9 48%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  border-left: 4px solid #1565c0;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    0 2px 10px rgba(15, 23, 42, 0.06);

  @media (max-width: 900px) {
    flex-basis: 100%;
    justify-content: flex-start;
  }
`;

/** Painel que agrupa modo (Período/Mês) + datas + Filtrar */
export const FilterControlPanel = styled.div`
  margin-top: 2px;
  padding: 16px 18px 18px;
  background: linear-gradient(165deg, #fbfcfe 0%, #f1f5f9 48%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  border-left: 4px solid #1565c0;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    0 2px 10px rgba(15, 23, 42, 0.06);
`;

export const ExtratoDescritivoScroll = styled.div`
  max-height: 420px;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fafbfc;
  padding: 10px 12px;
  box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.04);
`;

/** Linha superior do card de filtro (cliente) */
export const FilterClienteLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 14px;
  width: 100%;
  margin: 0 0 16px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);

  & .filter-cliente-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 10px;
    flex: 1;
    min-width: 0;
  }

  & .filter-cliente-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #64748b;
    text-transform: uppercase;
  }

  & .filter-cliente-name {
    font-size: 15px;
    font-weight: 600;
    color: #152b4e;
    line-height: 1.3;
    word-break: break-word;
  }

  & .filter-cliente-shuffle {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
    cursor: pointer;
    transition:
      background 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease;

    &:hover {
      background: #f8fafc;
      border-color: #cbd5e1;
      box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
    }
  }
`;

/** Área dos radios “Período / Mês” */
export const FilterModeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 18px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px dashed #cbd5e1;

  & > * {
    margin-right: 0;
    margin-bottom: 0;
  }

  & .filter-label {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    letter-spacing: 0.02em;

    & svg {
      opacity: 0.85;
    }
  }

  & .charge-filter-radios > div > div {
    gap: 4px 0;
  }
`;
